import React from "react";
import errorImg from "assets/500.jpg";
import PropTypes from "prop-types";

import Translate from "utils/translate";

import MessagePage from "./MessagePage";

const { t } = new Translate("ErrorBoundary");

const ErrorMessagePage = ({ message, title }) => (
  <MessagePage
    backgroundUrl={errorImg}
    message={message}
    redirectLabel={t("back")}
    redirectTo={window.location.origin}
    title={title}
  />
);

ErrorMessagePage.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default ErrorMessagePage;
